<template>
  <page :navType="'form4868'">
    <div id="top-hero" class="top-hero pt-5 pb-4">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="font-weight-bold text-uppercase text-center">
              NEED MORE TIME TO FILE YOUR TAXES?
            </h1>
            <h5 class="font-weight-bold text-center">
              Get a guaranteed 6-month extension to file your tax return. Fast, secure and IRS-approved.
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div class="april15-warning pt-5 pb-4" v-if="taxDayFinished">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h5 class="font-weight-bold text-center">
              <font-awesome-icon icon="fa-solid fa-exclamation-circle"/>
              You can file Form 4868 only by April 15 (or the next business day if it falls on a weekend or
              holiday).
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div class="banner-root">
      <div class="container">
        <div class="banner pt-60 pb-60">
          <div class="banner-right mt-3">
            <div class="find-out-input__panel px-5 pt-4 pb-4">
              <h3 class="font-weight-bold text-uppercase text-center mb-4">
                GET YOUR <SPAN style="color: #0098c3">EXTENSION</SPAN> NOW
              </h3>
              <div class="row mb-2">
                <div class="offset-2 col-8">
                  <label class="form-control-label light-gray"
                    >First Name</label
                  >
                  <input
                    :class="[
                      'form-control',
                      errors.firstName ? 'is-invalid' : '',
                    ]"
                    type="text"
                    v-model="form4868Data.firstName"
                    placeholder="First Name"
                    :disabled="taxDayFinished"
                    v-on:keypress="isLetter($event)"
                  />
                </div>
                <div class="offset-2 col-8">
                  <label class="form-control-label light-gray">Last Name</label>
                  <input
                    :class="[
                      'form-control',
                      errors.lastName ? 'is-invalid' : '',
                    ]"
                    type="text"
                    v-model="form4868Data.lastName"
                    placeholder="Last Name"
                    :disabled="taxDayFinished"
                    v-on:keypress="isLetter($event)"
                  />
                </div>
                <div class="offset-2 col-8">
                  <label class="form-control-label light-gray">Phone Number</label>
                  <input
                    :class="['form-control', errors.phone ? 'is-invalid' : '']"
                    type="text"
                    v-model="form4868Data.phone"
                    placeholder="Phone Number"
                    :disabled="taxDayFinished"
                    v-mask="'###-###-####'"
                  />
                </div>
                <div class="offset-2 col-8">
                  <label class="form-control-label light-gray">Email</label>
                  <input
                    :class="['form-control', errors.email ? 'is-invalid' : '']"
                    @keydown.space="(event) => event.preventDefault()"
                    type="text"
                    v-model="form4868Data.email"
                    :disabled="taxDayFinished"
                    placeholder="Email Address"
                  />
                </div>
              </div>

              <div class="row offset-2">
                <div
                  v-if="hasErrors"
                  class="d-flex justify-content-center mb-2 text-danger flex-column">
                  <div v-for="(error, i) in errors" :key="i">
                    <div v-if="error" class="mb-2">
                      {{ error }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center mb-4 mt-4">
                <button
                  class="btn btn-green font-weight-bold text-uppercase md-width"
                  v-on:click="onApply"
                  :disabled="taxDayFinished || isSubmitting"
                >
                  <span v-if="isSubmitting">Submitting...</span>
                  <span v-if="!isSubmitting">Submit</span>
                </button>
              </div>

              <div class="row">
                <div class="col-12 col-md-10 offset-0 offset-md-1">
                  <div class="d-flex justify-content-center align-items-center">
                    <font-awesome-icon
                      class="mr-2"
                      style="color: #0094be"
                      icon="lock"/>
                    <span style="font-size: 12px">
                      Your personal information is secured through SSL Encryption
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="banner-left">
            <div class="desc-wrapper">
              <div class="info-row d-flex my-5 pr-4">
                <div>
                  <img src="@/assets/secure.svg" alt="" width="70" height="70" />
                </div>
                <div class="info-text ml-4">
                  <h5 class="font-weight-bold form-desc-title">Authorized IRS e-file Provider</h5>
                  <span class="form-desc-subtitle">
                    File with confidence.
                  </span>
                </div>
              </div>
              <div class="info-row d-flex mb-5 pr-4">
                <div>
                  <img src="@/assets/calendar-plus.svg" alt="" width="70" height="70" />
                </div>
                <div class="info-text ml-4">
                  <h5 class="font-weight-bold form-desc-title">6-Month Extension</h5>
                  <span class="form-desc-subtitle">
                    File your taxes as late as October 15th without penalties.
                  </span>
                </div>
              </div>
              <div class="info-row d-flex mb-5 pr-4">
                <div>
                  <img src="@/assets/speed-alt.svg" alt="" width="70" height="70" />
                </div>
                <div class="info-text ml-4">
                  <h5 class="font-weight-bold form-desc-title">Fast Process</h5>
                  <span class="form-desc-subtitle">
                    Complete your extension filing in under 5 minutes.
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="py-4">
      <div class="container">
        <div class="row my-5">
          <div class="col-sm-8 offset-sm-2 col-12 offset-0">
            <h1 class="mb-3 text-center font-weight-bold">
              Why Choose 97tax?
            </h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-12 mb-5">
            <div class="mb-3">
              <img src="@/assets/secure.svg" alt="" width="70" height="70" class="svg-black"/>
            </div>
            <div class="info-text">
              <h5 class="font-weight-bold form-desc-title">Authorized IRS e-file Provider</h5>
              <span class="form-desc-subtitle">
                File with confidence through our IRS-authorized platform.
              </span>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 mb-5">
            <div class="mb-3">
              <img src="@/assets/calendar-plus.svg" alt="" width="70" height="70" class="svg-black"/>
            </div>
            <div class="info-text">
              <h5 class="font-weight-bold form-desc-title">6-Month Extension</h5>
              <span class="form-desc-subtitle">
                File your taxes as late as October 15th without penalties.
              </span>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 mb-5">
            <div class="mb-3">
              <img src="@/assets/speed-alt.svg" alt="" width="70" height="70" class="svg-black"/>
            </div>
            <div class="info-text">
              <h5 class="font-weight-bold form-desc-title">Fast Process</h5>
              <span class="form-desc-subtitle">
                Complete your extension filing in under 5 minutes.
              </span>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 mb-5">
            <div class="mb-3">
              <img src="@/assets/lock-closed.svg" alt="" width="70" height="70" class="svg-black"/>
            </div>
            <div class="info-text">
              <h5 class="font-weight-bold form-desc-title">Secure Filing</h5>
              <span class="form-desc-subtitle">
                Bank-level encryption protects your sensitive information.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="py-4">
      <div class="container">
        <div class="row mb-5">
          <div class="col-sm-8 offset-sm-2 col-12 offset-0">
            <h1 class="mb-3 text-center font-weight-bold">
              What is the Tax Return Extension?
            </h1>
            <h4 class="light-gray text-center font-weight-bold">
              It is an IRS procedure that allows you to request more time to file your taxes.
              It gives you time until October 15 to file without penalties.
            </h4>
          </div>
        </div>

        <div class="what-section row">
          <div class="col-sm-12 col-md-6">
            <h3 class="font-weight-bold">Understanding Tax Return Extension</h3>
            <p>
              Personal Tax Return Extension (Form 4868) is for individual or joint taxpayers to apply
              for an additional 6 months to file IRS Form 1040, 1040A, 1040-EZ, 1040NR, 1040NR-EZ,
              1040-PR or 1040-SS.
            </p>
            <p>
              The IRS doesn't require a reason to extend, and it's automatic. But you are required to
              accurately estimate your tax liability and file IRS Form 4868 by the due date of your return.
            </p>
            <p>
              <b>Note</b>: You still need to pay any tax due by the original IRS deadline; the Form 4868
              extension does not extend the time to pay.
            </p>
          </div>

          <div class="col-sm-12 col-md-6">
            <h3 class="font-weight-bold">We Work Fast for you</h3>
            <p>
              After you place an order, it’ll be reviewed for any errors and will be transmitted securely through
              our IRS-authorized, e-filing network.
            </p>
            <p>
              We will send you updates by email about the status of your extension. If your Form 4868 is rejected
              for any reason, we will notify you immediately and work with you to make the corrections necessary.
            </p>
          </div>
        </div>

        <div class="hidden-xs-only my-5 d-flex justify-content-center">
          <a
            class="btn btn-green font-weight-bold text-uppercase px-5"
            href="#top-hero"
            style="text-decoration: none">
            CLICK HERE TO GET YOUR APPLICATION STARTED NOW
          </a>
        </div>
      </div>
    </div>

    <div class="second-part">
      <div class="container">
        <div class="row py-3">
          <div class="col-sm-10 offset-sm-1 col-12 offset-0">
            <h1 class="mb-4 text-center font-weight-bold">Did you know?</h1>
            <h4 class="text-center">
              Most taxpayers can file Form 4868 to request an automatic six-month tax filing
              extension. You don’t need to give a reason for requesting an extension, but if
              your request is denied, the IRS will contact you to let you know why.
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="container pt-5 pb-5">
      <h1 class="text-center font-weight-bold my-3">Frequently Asked Questions</h1>
      <h4 class="light-gray text-center mb-5">We have lots of answers</h4>
      <div class="my-3" id="embedded_faq">
        <form4868-faq></form4868-faq>
      </div>
    </div>

    <our-clients></our-clients>

  </page>
</template>

<script>
import $ from "jquery";
import "bootstrap";
import { AXIOS } from "../scripts/http-common";
import { SiteUtils } from "../scripts/site-common";

export default {
  components: {},
  name: "PenaltyWaiver",

  data() {
    return {
      isSubmitting: false,
      form4868Data: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
      },
      errors: {
        firstName: false,
        lastName: false,
        phone: false,
        email: false,
      },
      hasErrors: false,
      taxDayFinished: SiteUtils.isTaxDayFinished(),
    };
  },
  methods: {
    isLetter(e) {
      if (e.keyCode === 32) return true;
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char)) return true;
      else e.preventDefault();
    },

    onApply() {
      this.isSubmitting = true;
      let required = ["firstName", "lastName", "email"];
      this.hasErrors = false;

      required.forEach((p) => {
        if (
          !this.form4868Data[p] ||
          this.form4868Data[p].trim().length === 0
        ) {
          this.errors[p] = true;
          this.hasErrors = true;
        } else {
          this.errors[p] = false;
        }
      });

      let checkFirstName = SiteUtils.validateFirstName(
        this.form4868Data.firstName
      );
      if (checkFirstName) {
        this.errors.firstName = checkFirstName;
        this.hasErrors = true;
      }

      let checkLastName = SiteUtils.validateLastName(
        this.form4868Data.lastName
      );
      if (checkLastName) {
        this.errors.lastName = checkLastName;
        this.hasErrors = true;
      }

      let checkEmailAddressErrorMsg = SiteUtils.validateEmail(
        this.form4868Data.email
      );
      if (checkEmailAddressErrorMsg) {
        this.errors.email = checkEmailAddressErrorMsg;
        this.hasErrors = true;
      }

      let checkPhoneNumberErrorMsg = SiteUtils.validatePhone(
        this.form4868Data.phone
      );
      if (
        screen.width >= 576 &&
        checkPhoneNumberErrorMsg &&
        this.form4868Data.phone
      ) {
        this.errors.phone = checkPhoneNumberErrorMsg;
        this.hasErrors = true;
      }

      if (this.hasErrors) {
        this.isSubmitting = false;
        return;
      }

      if (screen.width >= 576) {
        this.form4868Data.phone = SiteUtils.standardizePhone(
          this.form4868Data.phone
        );
      }

      const form4868Obj = {
        firstName: this.form4868Data.firstName,
        lastName: this.form4868Data.lastName,
        phone: this.form4868Data.phone,
        email: this.form4868Data.email,
      };

      console.log(form4868Obj);
      AXIOS.post("/efile/form4868", form4868Obj)
        .then((result) => {
          console.log(result);
          this.$router.push("/form4868-checkout");
        })
        .catch((err) => {
          console.log("Something went wrong: ", err)
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },

  mounted() {
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:400,700,800,900,900i");
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #aaa9a9;
  opacity: 1; /* Firefox */
  font-weight: 300;
}

* {
  font-family: "Raleway", sans-serif;
}

.top-hero {
  background-color: #0094be;
  color: #fff;
}

.april15-warning {
  background-color: #ffc067;
  color: #fff;
}

.find-out-input__panel {
  background-color: #f5f5f5;
}

.form-control-label {
  font-size: 12px;
  margin-bottom: 0;
}

.md-width {
  width: 450px;
}

.banner-root {
  background-color: #f4fbf9;
}
.pt-60 {
  padding-top: 60px;
}
.pb-60 {
  padding-bottom: 60px;
}
.banner-text {
  font-family: "PT Sans", serif;
  font-style: normal;
  font-weight: 700;
  font-size: 60px;
  line-height: 74px;
  color: #252020;
}
.green-underline {
  text-decoration: underline;
  text-decoration-color: #2ac44c;
}
.banner {
  display: flow-root;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.banner-left {
  width: 460px;
  margin: 0 auto;
  padding-bottom: 20px;
  float: left;
}
.banner-right {
  width: 100%;
  max-width: 650px;
  margin: 0 auto;
  position: relative;
  float: right;
}
.banner-image {
  width: 100%;
}

.banner-subtext {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;

  color: #817e7e;
  padding: 15px 0px 15px 0px;
}

@media only screen and (max-width: 862px) {
  .banner-text {
    font-size: 48px;
    line-height: 58px;
  }
}

@media only screen and (max-width: 1199px) {
  .pt-60 {
    padding-top: 45px;
  }
  .pb-60 {
    padding-bottom: 5px;
  }

  .banner-left {
    width: 100%;
    margin: 0 auto;
  }
  .banner-right {
    float: left;
  }
}

.second-part {
  font-family: "PT Sans", serif;
  background: #0094be;
  color: #fff;
  padding: 30px 0px 40px 0px;
}

.panel-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.panel {
  background: #f4fbfe;
  border-radius: 16px;
  width: 49%;
  padding: 32px;

  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;

  /* Text color */

  color: #252020;
  margin: 20px 0px;
}

.panel-title {
  margin: 10px 0px;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;

  color: #252020;
}

.m15 {
  margin-right: -15px;
  margin-left: -15px;
}

ul {
  list-style: none; /* Remove default bullets */
}

ul li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #0094be; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1em; /* Also needed for space (tweak if needed) */
  margin-left: -1em; /* Also needed for space (tweak if needed) */
}

li {
  margin-left: -1em;
}

@media only screen and (max-width: 768px) {
  .panel {
    width: 100%;
  }
}

.bggray {
  background: #f8faf9;
  border-radius: 16px;
}

@media only screen and (max-width: 1024px) {
}

@media only screen and (max-width: 768px) {
}

.light-gray {
  color: #a5a5a5;
}

.what-section p {
  line-height: 2em;
}

.svg-black {
  filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(320deg) brightness(0%) contrast(75%)
}
</style>



// WEBPACK FOOTER //
// src/pages/Form4868.vue